import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { forgetPasswordSchema } from "../../schema";
import { forgotpassapi } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

const initialValues = {
  email: "",
};

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const toast = useRef(null);

  const handlereset = async (action) => {
    forgotpassapi(values)
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: `${response?.data?.message}`,
        });
        action.resetForm();
        setTimeout(() => {
          navigate("/");
        }, [1000]);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: forgetPasswordSchema,
      onSubmit: (values, action) => {
        handlereset(action);
      },
    });

  return (
    <>
      <div className="all-login-signup-forgot-pass-model">
        <Toast ref={toast} />
        <div className="loop-text-cls-add">
          <h1>The Loop</h1>
        </div>
        <div class="auth_screen">
          <div class="row">
            <div class="col-lg-12">
              <div class="auth_box">
                <div class="auth_body mt-4 w-100">
                  <h6 class="mb-4">Forgot Password?</h6>
                  <form onSubmit={handleSubmit} class="">
                    <div class="form-content">
                      <div class="form-group">
                        <label class="form-label all-label-same">Email</label>
                        <input
                          type="email"
                          name="email"
                          formcontrolname="email"
                          maxlength="50"
                          class="form-control input-underline input-lg"
                          placeholder="Email Id"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.email && touched.email ? (
                          <p className="form-error">{errors.email}</p>
                        ) : null}
                      </div>
                      <div class="mt-2 text-end">
                        <div class="row mt-4 mb-2">
                          <div class="col-lg-12">
                            <button
                              type="submit"
                              class="btn fill_btn same-all-btn-primary"
                              // onClick={handlereset}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
